import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from "@material-ui/core/Grid";

const LoadingDialog = (props) => {
    return (
        <Dialog open>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <CircularProgress />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default LoadingDialog;
